import { CustomerApplicationSummary } from "Hooks/Api/apiCustomerApplications";
import { RiskRatingsWidget } from "Views/Components/Widgets/RiskRatingWidget";

export function CustomerApplicationRiskRatingsWidget(props: { model: CustomerApplicationSummary }) {
	const { model } = props;
	return (
		<RiskRatingsWidget model={{}} />
	)
}